module.exports = __webpack_public_path__ + "static/media/BGPHSPASpa.aa03b4f6.pdf";